//Modules
import React from "react"
//Styles
import styled from "styled-components"
import { flex, spacing, font } from "../../Utilities"

const Lesson = ({ lesson }) => {
  const { name, googleDoc, youtubeVideo, previewImage } = lesson.fields
  const {
    description,
    file: { url },
  } = previewImage.fields

  return (
    <StyledDemoLesson url={url}>
      <a className="preview" href={googleDoc}>
        <h2>{name}</h2>
      </a>

      <div className="video">
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${youtubeVideo}`}
          frameBorder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={name}
        />
      </div>
    </StyledDemoLesson>
  )
}

const StyledDemoLesson = styled.article`
  display: grid;
  grid-template-columns: 90vmin;
  grid-template-rows: 1fr 1fr;
  grid-gap: ${spacing.S};

  @media (min-width: 1024px) {
    grid-template-columns: 65vmin 65vmin;
    grid-template-rows: 1fr;
  }

  @media (min-width: 1320px) {
    grid-template-columns: 85vmin 85vmin;
    grid-template-rows: 1fr;
  }

  .preview {
    ${flex("column", "flex-start", "flex-start")};
    background: ${props => `url(${props.url})`};
    background-size: cover;
    height: 100%;
    width: 100%;

    h2 {
      ${font("M")};
      padding: ${spacing.M};
      letter-spacing: 0.1rem;
      text-shadow: 0px 2px 20px black;
    }
  }

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video {
    overflow: hidden;
    position: relative;
    max-height: 31.5rem;

    &:after {
      padding-top: 56.25%;
      display: block;
      content: "";
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`

export default Lesson
